module.exports = __webpack_public_path__ + "img/chpc_index_honor8.95285404.png";